import { ReactElement } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { HeaderArrowsSkeleton } from 'newcomponents/UI/SwiperSlider/Skeleton/HeaderArrowsSkeleton';
import { CenteredSpin } from '../Spin';
import './index.less';

type TAtoZSkeletonProps = {
  includeSearch: boolean;
  excludeSpin?: boolean;
  sliderArrowsAToZ?: boolean;
};

const atoZSkeletonDefaultProps = {
  includeSearch: false
} as TAtoZSkeletonProps;

export const AtoZSkeleton = ({
  includeSearch = false,
  excludeSpin,
  sliderArrowsAToZ
}: TAtoZSkeletonProps = atoZSkeletonDefaultProps): ReactElement => {
  return (
    <div className="atoz__skeleton__wrapper">
      {includeSearch && (
        <div className="atoz__skeleton__search">
          <Skeleton
            title={{
              style: {
                height: 40,
                width: '100%',
                margin: '0',
                borderRadius: '4px'
              }
            }}
            paragraph={false}
            active
          />

          {SpringConfigs.THEME_SWITCHER && (
            <div className="atoz__skeleton__themeSwitcher">
              <Skeleton
                title={{
                  style: {
                    height: 32,
                    width: 60,
                    margin: 0,
                    borderRadius: 40
                  }
                }}
                paragraph={false}
                active
              />
            </div>
          )}
        </div>
      )}

      {sliderArrowsAToZ ? (
        <div className="atoz__skeleton__sliderArrows">
          <HeaderArrowsSkeleton />
        </div>
      ) : null}

      <div className="atoz__skeleton__tabs">
        {Array.from({ length: 4 }, (v, i) => i).map(key => (
          <div key={key} className="atoz__skeleton__singleTab">
            <Skeleton.Avatar size={EIconSize._24} active />
            <Skeleton
              title={{ style: { height: 9, width: 40, margin: '5px auto' } }}
              paragraph={false}
              active
            />
          </div>
        ))}
      </div>
      {!excludeSpin && <CenteredSpin />}
    </div>
  );
};
